import { Serializable } from '../../core/models/serializable';
import { EducationalInstitutionModel } from '@admin/shared/models/educational-institution-model';
import { EducationLevelModel } from '@admin/shared/models/education-level-model';

export class EducationalProgramModel
  implements Serializable<EducationalProgramModel>
{
  fromObject(object: any): EducationalProgramModel {
    Object.assign(this, object);
    return this;
  }
  toObject() {
    throw new Error('Method not implemented.');
  }

  public educationalProgramId: number;
  public educationalInstitution: EducationalInstitutionModel;
  public code: string;
  public name: string;
  public nameLatin: string;
  public educationalLevel: EducationLevelModel;
  public createDate: Date;
  public startDate: Date;
  public endDate: Date;
  public isActive: boolean;
}
